import numeral from 'numeral';

export function formatNumber(value: unknown, format = '0,0.00'): string {
  if (typeof value !== 'number') {
    return '-';
  }

  return numeral(value).format(format);
}
